import React from 'react'
import PropTypes from 'prop-types'

export default class StatusModule extends React.Component {

  static propTypes = {
    jobInfo: PropTypes.shape().isRequired
  }

  getCurrentStatus = () => {
    const statusModule = this.props.jobInfo.modules.status
    switch (statusModule.value) {
      case 'accepted':
        return 'Accepted'
      case 'onhold':
        return 'In Progress'
      case 'completed':
        return 'Completed'
      default:
        return 'Open'
    }
  }

  render() {
    return (
      <div style={{ color: '#757575', fontSize: 14 }}>
        Current Status: { this.getCurrentStatus() }
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/schedule/common/modules/status/StatusModule.js